/**
 * Permet d'escaper tous les < > etc
 */
export function txtEscape(text: string): string {
    if (text == undefined) {
        return "";
    }
    return text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}